module.exports = __webpack_public_path__ + "static/img/6305_phase_function_Paper_Points.e41521c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6305_phase_function_Paper_Points.png
// module id = bv6R
// module chunks = 0